//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.AccountResale
import com.tixforgigs.apax.models.ItemType
import com.tixforgigs.apax.models.PersonalizationField
import com.tixforgigs.apax.models.TicketMetadata

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The ticket account model, which is used for administration by the customer
* 
* @param contingentId The unique identifier of the contingent to which this ticket belongs
* @param eventId The unique identifier of the event to which this ticket belongs
* @param isPersonalized [DEPRECATED - use personalizationFields] personalizationFields == null indicates isPersonalized == false [OLD] Boolean indicating whether the ticket is personalized
* @param itemType 
* @param metadata 
* @param runningValue A sequential number that is incremented when changes are made
* @param ticketId The unique identifier of the ticket
* @param code The unique ticket code for entry control
* @param dbVersion The version from db. Used for requesting updates based on a version.
* @param personalizationFields A list of personalization fields available for this event. Mandatory fields are marked with required
* @param productId The unique identifier of the product to which this ticket belongs
* @param resale 
* @param ticketOwnerEmail The email address of the ticket holder
*/
@Serializable

data class AccountTicket (


      /* The unique identifier of the contingent to which this ticket belongs */
    @SerialName(value = "contingentId") @Required val contingentId: kotlin.Int,


      /* The unique identifier of the event to which this ticket belongs */
    @SerialName(value = "eventId") @Required val eventId: kotlin.Int,


      /* [DEPRECATED - use personalizationFields] personalizationFields == null indicates isPersonalized == false [OLD] Boolean indicating whether the ticket is personalized */
    @Deprecated(message = "This property is deprecated.")
    @SerialName(value = "isPersonalized") @Required val isPersonalized: kotlin.Boolean,


      @SerialName(value = "itemType") @Required val itemType: ItemType?,


      @SerialName(value = "metadata") @Required val metadata: TicketMetadata,


      /* A sequential number that is incremented when changes are made */
    @SerialName(value = "runningValue") @Required val runningValue: kotlin.Int,


      /* The unique identifier of the ticket */
    @SerialName(value = "ticketId") @Required val ticketId: kotlin.Int,


      /* The unique ticket code for entry control */
    @SerialName(value = "code") val code: kotlin.String? = null,


      /* The version from db. Used for requesting updates based on a version. */
    @SerialName(value = "dbVersion") val dbVersion: kotlin.Long? = 0L,


      /* A list of personalization fields available for this event. Mandatory fields are marked with required */
    @SerialName(value = "personalizationFields") val personalizationFields: kotlin.collections.List<PersonalizationField>? = null,


      /* The unique identifier of the product to which this ticket belongs */
    @SerialName(value = "productId") val productId: kotlin.Int? = null,


      @SerialName(value = "resale") val resale: AccountResale? = null,


      /* The email address of the ticket holder */
    @SerialName(value = "ticketOwnerEmail") val ticketOwnerEmail: kotlin.String? = null


) {




  }

